import React from "react";

/**
 * Prime Wiki Services wordmark logo.
 * `variant` controls which image to use:
 *   - "dark"  → logo.png (navy/emerald logo for light backgrounds)
 *   - "light" → logo-white.png (white logo for dark backgrounds)
 */
export const BrandLogo = ({ variant = "dark", className = "" }) => {
  const src =
    variant === "light"
      ? "/assets/img/logo-light.png"
      : "/assets/img/logo-dark.png";
  return (
    <div
      className={`flex items-center ${className}`}
      data-testid="brand-logo"
    >
      <img
        src={src}
        alt="Prime Wiki Services"
        className="h-10 w-auto object-contain sm:h-11"
        loading="eager"
        decoding="async"
      />
    </div>
  );
};

export default BrandLogo;
